// extracted by mini-css-extract-plugin
export var card = "_bb-1";
export var container = "_bb-0";